import React, {useContext} from 'react';
import {Redirect} from 'react-router-dom';
import {TabbedOverviewPage, ReadinessSolutionOverviewSection} from '../components/OverviewSections.comp';
import {AuthContext} from '../../../context/auth';
import {getPlanStage} from '../../../utils/productAccess';

// P1 only (see SchoolDashboardList). /school-dashboard and /overview redirect
// here for every plan, so a P0 user is sent on to their first intro page.
const AboutReadinessSolutionPage = () => {
    const {authUser} = useContext(AuthContext);
    if (getPlanStage(authUser) === 'P0') {
        return <Redirect to="/dq_pro/school-dashboard/overview/about-assessment"/>;
    }
    return (
        <TabbedOverviewPage
            skipNoDataGate
            tabs={[
                {
                    label: 'Child Online Safety (COS) Readiness Solution',
                    content: <ReadinessSolutionOverviewSection/>,
                },
            ]}
        />
    );
};

export default AboutReadinessSolutionPage;
